<a class="social-button {{'social-button-' + buttonClass}}"
	[ngClass]="{'active' : iconState}"
	(click)="clickEvent($event)"
	href="javascript:void(0)"
	[@iconAnimation]="iconState ? 'active' : 'inactive'">
	<span class="number" *ngIf="displayCounter">{{displayedNumber}}</span>
	<i [ngClass]="iconClass"></i>
</a>
